/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_view_card_data = /** @type {(inputs: {}) => string} */ () => {
	return `Ver datos de la tarjeta`
};

const en_cards_view_card_data = /** @type {(inputs: {}) => string} */ () => {
	return `View card data`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_view_card_data = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_view_card_data(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_view_card_data", locale)
	if (locale === "es") return es_cards_view_card_data(inputs)
	return en_cards_view_card_data(inputs)
};
export { cards_view_card_data as "cards.view_card_data" }